export default "__VITE_ASSET__Dd52z3fj__"